import buttonPrice from '@/components/market/v2/button-price/button-price.vue';

export default {
  components: { buttonPrice },
  emits: ['click'],

  props: {
    // button-price content
    price: { type: Number, default: 0 },
    text: { type: String, required: true },
    win: { default: null },
    sell: { default: null },

    // visual variant: 'buy-yes' | 'sell-yes' | 'buy-no' | 'sell-no'
    variant: { type: String, required: true },

    // active / selection state
    isActive: { type: Boolean, default: false },
    isOn: { type: Boolean, default: false },
    operationValue: { type: String, default: null },

    // sell-disabled guard
    saleDisabled: { type: Boolean, default: false },
    disabledTooltip: { type: String, default: "You don't have any shares available to sell." },
  },

  computed: {
    buttonClass() {
      return {
        'market-button-direction': true,
        [`market-button-direction--${this.variant}`]: true,
        'market-button-direction--active': this.isActive,
        'market-button-direction--on': this.isOn,
        'market-button-direction--off': !this.isOn,
        'market-button-direction--off-yes': this.operationValue === 'yes',
        'market-button-direction--off-no': this.operationValue === 'no',
        'market-button-direction--sale-disabled': this.saleDisabled,
      };
    },
  },

  methods: {
    onClick() {
      if (!this.saleDisabled) {
        this.$emit('click');
      }
    },
  },
};
